<template>
  <v-flex
    xs12 sm4
    class="text-xs-center text-sm-center text-md-center text-lg-center"
  >
    <img
      v-if="file.url || placeholder"
      :src="file.url || placeholder"
      height="150"
    />
    <v-text-field
      :label="file.name || placeholder"
      @click="pickFile"
      v-model="file.name"
      prepend-icon="attach_file"
    ></v-text-field>
    <input
      :ref="ref"
      type="file"
      class="d-none"
      accept="image/*"
      @change="fileSelected"
    />
  </v-flex>
</template>
<script>
export default {
  name: 'uploadButton',
  props: {
    selectedCallback: Function,
    modelTarget: String,
    title: String,
    placeholder: String
  },
  data () {
    return {
      file: {
        name: '',
        url: ''
      },
      ref: 'fileInput' + Math.random() + Date.now()
    }
  },
  methods: {
    pickFile () {
      this.$refs[this.ref].click()
    },
    fileSelected (e) {
      let vm = this
      if (e.target.files) {
        this.file = e.target.files[0]
        if (this.selectedCallback) {
          if (e.target.files[0]) {
            this.selectedCallback(e.target.files[0], this.modelTarget)
          } else {
            this.selectedCallback(null, null)
          }
        }
      }
    }
  }
}
</script>
